export const BOOKING_STATUS = {
  CONFIRMED: "CONFIRMED",
  ADMIN_CONFIRMED: "ADMIN_CONFIRMED",
  DONE: "DONE",
  CHECKED_OUT: "CHECKED_OUT",
};

export const PERMISIONS = {
  READ: "read",
  ADD: "add",
  UPDATE: "update",
  DELETE: "delete",
};

export const GLOBAL_FEATURES = {
  EnquiryDashboard: "EnquiryDashboard",
  HKStaff: "HKStaff",
  HKSupervisor: "HKSupervisor",
  HideBlockRooms: "HideBlockRooms",
  HideUnBlockRooms: "HideUnBlockRooms",
  PaymentLink: "PaymentLink",
  OtaRoomMappingFlexiAi: "OtaRoomMappingFlexiAi",
  POSOrderRemoveFromRoomBill: "POSOrderRemoveFromRoomBill",
  PastDateCreateBooking: "PastDateCreateBooking",
};

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
};

export const AGENT_REGISTRY = {
  OTA_ROOM_ASSIGNMENT_CONFIG_AGENT: "otaRoomAssignmentConfigAgent",
};

export const AI_RESPONSE_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
};

export const MOMENT_DATE_FORMATS = {
  YYYYMMDD_WITH_HYPHEN: "YYYY-MM-DD",
  DDMMYYYY_WITH_BACKSLASH: "DD/MM/YYYY",
};

export const AI_SCANNERS = {
  DOCUMENTAI: "DOCUMENTAI",
  IDGURU: "IDGURU",
  AMBIRSCAN: "AMBIRSCAN",
  AMBIRSCAN_WC: "AMBIRSCAN_WC",
};

export const AI_SCAN_DOCUMENT_TYPES = {
  PASSPORT: "Passport",
  DRIVERS_LICENSE: "Drivers License",
};

export const DATE_FORMATS = {
  DATE_TIME_1: "dd MMM yyyy hh:mm a",
  DATE_1: "dd MMM yyyy",
  DATE_2: "yyyy-MM-dd",
  DATE_3: "MMM dd",
};

export const RATE_PLANS = {
  STANDARD_PLAN: "Standard Plan",
};

/**
 * Logged-in emails allowed to see Booking import under Property configuration (non–master users).
 * Only property ADMIN (not subusers): pass `ADMINRIGHTS` as `"ADMIN"`.
 */
export const BOOKING_IMPORT_ALLOWED_EMAILS = [
  "nithints24work@gmail.com",
  "manish.kumar@nia.one",
  "kumar699.abhishek@gmail.com"
];

const normalizeEmail = (e) => (e || "").trim().toLowerCase();

/**
 * @param {string} [sessionEmail] - `localStorage` `email` (logged-in user)
 * @param {string} [adminRights] - `ADMINRIGHTS` from access control
 */
export function isBookingImportAllowedForHotelAdmin(
  sessionEmail,
  adminRights
) {
  if (adminRights !== "ADMIN") return false;
  const emailNorm = normalizeEmail(sessionEmail);
  return BOOKING_IMPORT_ALLOWED_EMAILS.some(
    (allowed) => normalizeEmail(allowed) === emailNorm
  );
}

export const DEFAULT_PHONE_NUMBER = "0000000000";
